import {FC, useState} from "react";
import {config} from "../../config";
import {useApiCall} from "@jane/lib/src/api";
import {TeamSpaceTemplate} from "@jane/lib/src/api/repositories/documentation-library-repository";
import {Input} from "@jane/lib/src/components/form/Input";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";
import {Select} from "@jane/lib/src/components/form/Select";

export const AddPageModal: FC<{ teamSpaceId: string, templates: TeamSpaceTemplate[], onFinished: () => void, parentItemId?: string }> = (props) => {
  const { documentations } = useApiCall(config)
  const [name, setName] = useState<string>('')
  const [template, setTemplate] = useState<string|null>(null)

  const selectedTemplate = props.templates.find(t => t.id === template)

  const save = async () => {
    await documentations.addPage(
      props.teamSpaceId,
      name,
      'page',
      props.parentItemId ? props.parentItemId : null,
      selectedTemplate ? selectedTemplate.content : null,
    )
    props.onFinished()
  }

  const templateOptions = {
    '-': 'Geen',
    ...Object.fromEntries(props.templates.map(t => [t.id, t.name])),
  }

  return <>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <Select label={'Sjabloon'} options={templateOptions} value={template === null ? '-' : template} onChange={(v) => setTemplate(v === '-' ? null : v)}  />
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </>
}